import { Pipe, PipeTransform } from '@angular/core';
import { DomSanitizer, SafeUrl } from '@angular/platform-browser';

@Pipe({
  name: 'uri',
})
export class UriPipe implements PipeTransform {
  constructor(private domSanitizer: DomSanitizer) {}

  transform(blob: Blob | string): SafeUrl {
    if (typeof blob === 'string') {
      return blob;
    }
    return this.domSanitizer.bypassSecurityTrustUrl(URL.createObjectURL(blob));
  }
}
